function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9998 3.16699C23.0568 3.16699 28.8336 8.94296 28.8337 16C28.8337 23.0572 23.0569 28.834 15.9998 28.834C8.94271 28.8338 3.16675 23.0571 3.16675 16C3.16692 8.94307 8.94282 3.16717 15.9998 3.16699Z",
  fill: "#437EFE",
  fillOpacity: 0.2,
  stroke: "#437EFE"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5334 17.3338H16.0001C15.2001 17.3338 14.6667 16.8005 14.6667 16.0005V9.46712C14.6667 8.66712 15.2001 8.13379 16.0001 8.13379C16.8001 8.13379 17.3334 8.66712 17.3334 9.46712V14.6671H22.5334C23.3334 14.6671 23.8667 15.2005 23.8667 16.0005C23.8667 16.8005 23.3334 17.3338 22.5334 17.3338Z",
  fill: "#437EFE"
});

function SvgTimeSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeSolid);
export default __webpack_public_path__ + "static/media/Time_solid.43596a82.svg";
export { ForwardRef as ReactComponent };